import React from "react";
import localeText from "../../../locale";

const ConfimeaFormSuccess = ({ email }) => {
  return (
    <section id="form" className="confimea-form-section">
      <div className="confimea-container">
        <div className="confimea-form-container">
          <div className="confimea-form" style={{ textAlign: "center", padding: "0" }}>
            <div
              className="confimea-confirmation-header flex justify-content-center py-6"
              style={{ borderRadius: "16px 16px 0 0" }}
            >
              <div className="confimea-form-success-icon">
                <i className="pi pi-envelope" style={{ fontSize: "2.5rem", color: "#fff" }}></i>
              </div>
            </div>
            <div className="confimea-confirmation-content">
              <div className="confimea-section-header mb-0 flex flex-column gap-4">
                <div>
                  <span className="confimea-section-badge">{localeText("formSuccessBadge")}</span>
                </div>
                <div className="confimea-form-success-title">{localeText("formSuccessTitle")}</div>
                <div className="confimea-form-success-subtitle">
                  {localeText("formSuccessSubtitle")}
                </div>
              </div>

              <div className="confimea-form-success-message text-left flex flex-column gap-4">
                <div className="flex align-items-center gap-3">
                  <div className="confimea-form-success-message-item-number">1</div>{" "}
                  <div className="confimea-form-success-message-item-text font-medium">
                    {localeText("formSuccessStep1")}
                  </div>
                </div>
                <div className="flex align-items-center gap-3">
                  <div className="confimea-form-success-message-item-number">2</div>{" "}
                  <div className="confimea-form-success-message-item-text font-medium">
                    {localeText("formSuccessStep2")}
                  </div>
                </div>
                <div className="flex align-items-center gap-3">
                  <div className="confimea-form-success-message-item-number">3</div>{" "}
                  <div className="confimea-form-success-message-item-text font-medium">
                    {localeText("formSuccessStep3")}
                  </div>
                </div>
              </div>
              <div className="text-sm mt-4" style={{ color: "rgba(80, 95, 121, 1)" }}>
                <p>{localeText("formSuccessEmailNotReceived")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaFormSuccess;
